import React from 'react';
import { Slot } from '@radix-ui/react-slot';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@app/shared/utils/common';

const paragraphVariants = cva('font-medium whitespace-pre-line', {
  variants: {
    variant: {
      primary: 'text-foreground',
      secondary: 'text-secondary-foreground',
      card: 'text-card-foreground',
      white: 'text-foreground',
      accent: 'text-accent',
    },
    size: {
      '2xs': 'text-2xs',
      xs: 'text-xs',
      sm: 'text-sm',
      md: 'text-base leading-[1.2]',
      lg: 'text-lg',
      xl: 'text-xl',
    },
  },
  defaultVariants: {
    variant: 'primary',
    size: 'md',
  },
});

interface ParagraphProps
  extends React.HTMLAttributes<HTMLParagraphElement>, VariantProps<typeof paragraphVariants> {
  asChild?: boolean;
}

const Paragraph = React.forwardRef<HTMLParagraphElement, ParagraphProps>(
  ({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : 'p';
    return (
      <Comp className={cn(paragraphVariants({ variant, size, className }))} ref={ref} {...props} />
    );
  }
);
Paragraph.displayName = 'Paragraph';

export { Paragraph };
